import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../helper/api_helper"

const Employee = () => {
    const initialFormState = {
        employee_id: 0,
        role_id_fk:'',
        employee_name: '',
        email_id : '',
        mobile_no : '',
        password:'',
        status: '0'
    };

    const [formData, setFormData] = useState(initialFormState);
    const [validated, setValidated] = useState(false);
    const [employeeList, setemployeeList] = useState([]);
    const [roleList, setroleList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Actions',
                cell: ({ row }) => (
                    <>
                        <i
                            className="ri-file-edit-fill text-primary cursor-pointer me-2"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                            style={{ fontSize: "18px" }}
                        />
                    </>
                ),
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                header: 'Employee Name',
                accessorKey: 'employee_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Role Name',
                accessorKey: 'role_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Email ID',
                accessorKey: 'email_id',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Mobile No',
                accessorKey: 'mobile_no',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Password',
                accessorKey: 'password',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition: 'status',
            },
        ],
        []
    );

    const handleEdit = (row) => {

        setFormData({
            employee_id: row.employee_id,
            role_id_fk : row.role_id_fk,
            employee_name: row.employee_name,
            email_id: row.email_id,
            mobile_no: row.mobile_no,
            password: row.password,
            status: row.status
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            showAlert('error', 'Oops...', 'Please fill in all required fields.');
            setValidated(true);
        } else {
            try {
                setValidated(false);
                const response = await post("/masters/employee", formData);
                if (response.status === 200) {
                    showAlert('success', 'Saved', response.message);
                    fetchData();
                    setFormData(initialFormState);
                } else {
                    showAlert('error', response.status, response.message);
                }
            } catch (err) {
                showAlert('error', 'Unexpected Error', err.message);
            }
        }
    };

    const handleReset = () => {
        setFormData(initialFormState);
        setValidated(false);
    };

    const fetchData = async () => {
        try {
            const response = await post("/masters/employee/list");
            if (response.status === 200) {
                setemployeeList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    const fetchRoleData = async () => {
        try {
            const response = await post("/settings/role/list");
            if (response.status === 200) {
                setroleList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
        fetchRoleData();
    }, []);

    return (
        <>
            <div class="page-header">
                <div>
                    <div class="page-header-title">Employee</div>
                    <div class="page-header-sub">Employee Management</div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3 col-sm-12 col-md-12">
                    <div className="card">
                        <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
                        <div className="card-header">
                            <h5 className="card-title mb-0">EMPLOYEE</h5>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <label>Employee Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="employee_name"
                                        name="employee_name"
                                        value={formData.employee_name}
                                        onChange={handleChange}
                                        required
                                        placeholder="employee"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label>Role Name</label>
                                    <select
                                        name="role_id_fk"
                                        className="form-control radius-4 form-select"
                                        value={formData.role_id_fk}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select</option>
                                        {roleList.map((role) => (
                                            <option key={role.role_id} value={role.role_id}>
                                            {role.role_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-12">
                                    <label>Email ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="email_id"
                                        name="email_id"
                                        value={formData.email_id}
                                        onChange={handleChange}
                                        required
                                        placeholder="Email ID"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label>Mobile No.</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="mobile_no"
                                        name="mobile_no"
                                        value={formData.mobile_no}
                                        onChange={handleChange}
                                        required
                                        placeholder="Mobile No"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label>Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                        placeholder="Password"
                                    />
                                </div>

                                <div className="col-md-12">
                                    <label>Status</label>
                                    <select
                                        className="form-control radius-8 form-select"
                                        id="status"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>Select</option>
                                        <option value="0">Active</option>
                                        <option value="1">In-Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                            <div className="col-md-12">
                                <button type="submit" className="btn btn-primary btn-sm" style={{ float: "right"}}>SAVE</button>
                                <button type="button" onClick={handleReset} className="btn btn-sm btn-primary">CLEAR</button>
                            </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
                <div className="col-lg-9 col-sm-12 col-md-12">
                    <div className="card basic-data-table">
                        <div className="card-header">
                        <h5 className="card-title mb-0">Employee List</h5>
                        </div>
                        <div className="card-body">
                        <Customtable
                            table_title="Employee List"
                            columns={columns}
                            data={employeeList}
                            isGlobalFilter={true}
                            isPagination={true}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            isExportButton={true}
                        />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Employee;
